(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chits-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('chits-recommendations')) {
    customElements.define('chits-recommendations', class extends HTMLElement {
      connectedCallback() {
        if (this.querySelector('.chits-recommendations') || this.loading) return;
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            this.observer.disconnect();
            this.loadRecommendations();
          }
        }, { rootMargin: '500px' });
        this.observer.observe(this);
      }
      disconnectedCallback() { this.observer?.disconnect(); }
      async loadRecommendations() {
        this.loading = true;
        try {
          const response = await fetch(this.dataset.url);
          if (!response.ok) return;
          const document = new DOMParser().parseFromString(await response.text(), 'text/html');
          const source = document.querySelector('chits-recommendations');
          if (source) this.innerHTML = source.innerHTML;
        } catch (error) { this.hidden = true; }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
